
<template>
  <div class="col-10 col-xl-7 mx-auto p-5 bg-white rounded">
    <h4 class="text-center">
      <img :src="icon" class="w-30-p rounded mr-2"/>
      <span class="align-bottom">Smartsupp</span>
    </h4>

    <div class="mt-5 text-center">
      Authorization complete. Click "Finish" to create the integration.
    </div>

    <div class="mt-5 d-flex justify-content-center">
      <!-- not using the v-busy-button directive here because we want to manage the button's disabled status manually -->
      <button class="btn btn-primary px-5"
              ref="connectButton"
              :disabled="loadingChannels"
              @click.prevent="promiseButton = connectIntegration()">
        Finish
      </button>
    </div>

  </div>
</template>

<script>
  import { SMARTSUPP_INTEGRATION } from '@/utils/integration.constants'
  import integrationService from '@/services/amio-api/integration.service'
  import channelService from '@/services/amio-api/channel.service'
  import * as Ladda from 'ladda'
  import 'ladda/css/ladda-themed.scss'
  import oauthService from '@/services/amio-api/oauth.service'

  export default {
    data() {
      return {
        channels: [],
        icon: SMARTSUPP_INTEGRATION.icon,
        loadingChannels: false,
        promiseButton: null,
        laddaButton: null
      }
    },

    methods: {
      async connectIntegration() {
        const { code } = this.$route.query
        if (!code) this.throwRedirectError('code')

        const [type, channelId, dateSignature] = this.$route.query.state.split('-')
        const expectedDateSignature = new Date(Date.now()).toLocaleString().split(',')[0]
        if (dateSignature !== expectedDateSignature) this.throwRedirectError('state')
        if (type !== SMARTSUPP_INTEGRATION.type) this.throwRedirectError('type')

        const channel = this.channels.find(channel => channel.id === channelId)
        if (!channel) this.throwRedirectError('channel')

        const response = await oauthService.oauthSmartsupp(code)

        const data = {
          type: 'smartsupp',
          access_token: response.data.access_token,
          channels: [
            {id: channelId}
          ]
        }

        // TODO make error framework
        return integrationService.create(data, [422])
          .then(integration => {
            this.clearConnectPromise()
            const id = integration.id
            this.$router.push({name: 'administration.integrations.detail', params: {id}})
          })
          .catch(err => {
            this.clearConnectPromise()
            this.formValidator_displayError(err)
          })
      },

      clearConnectPromise() {
        this.promiseButton = null
        this.laddaButton.stop()
        this.laddaButton = null
      },

      getChannels() {
        this.loadingChannels = true
        return channelService.list({offset: 0, max: 999})
          .then(({items}) => {
            this.channels = items
            this.loadingChannels = false
          })
          .catch(() => {
            this.loadingChannels = false
          })
      },

      throwRedirectError(value) {
        const errorMessage = `Invalid redirect, ${value} is not valid`
        log.error(errorMessage)
        throw new Error(errorMessage)
      }
    },

    watch: {
      promiseButton: function () {
        // start busy button whenever there's a promise waiting to be resolved
        // the busy button must be cleared manually by calling this.clearConnectPromise()
        if (this.promiseButton) {
          this.laddaButton = Ladda.create(this.$refs.connectButton)
          this.laddaButton.start()
        }
      }
    },

    mounted() {
      this.getChannels()
    }

  }
</script>
